const TPAG_VALIDOS = new Set([
  "01", "02", "03", "04", "05", "10", "11", "12", "13", "15", "16", "18", "19", "20", "90", "99",
]);

const REGRAS_DESCRICAO_TPAG = [
  { regex: /dinheiro|especie|esp[eé]cie|[aàá]\s*vista|avista/i, tpag: "01" },
  { regex: /cheque/i, tpag: "02" },
  { regex: /cart[aã]o\s*cr[eé]dito|cr[eé]dito/i, tpag: "03" },
  { regex: /cart[aã]o\s*d[eé]bito|d[eé]bito/i, tpag: "04" },
  { regex: /cr[eé]dito\s*loja|credi[aá]rio|fiado|a\s*prazo|prazo/i, tpag: "05" },
  { regex: /vale\s*alimenta/i, tpag: "10" },
  { regex: /vale\s*refei/i, tpag: "11" },
  { regex: /vale\s*presente/i, tpag: "12" },
  { regex: /vale\s*combust/i, tpag: "13" },
  { regex: /boleto/i, tpag: "15" },
  { regex: /dep[oó]sito\s*banc[aá]rio|dep[oó]sito/i, tpag: "16" },
  { regex: /transfer[eê]ncia\s*banc[aá]ria|transfer[eê]ncia|carteira\s*digital|ted\b|doc\b/i, tpag: "18" },
  { regex: /pix|pagamento\s*instant[aâ]neo/i, tpag: "20" },
];

function _normalizarCodigo(codigo) {
  if (codigo == null || String(codigo).trim() === "") return null;
  const normalizado = String(codigo).trim().padStart(2, "0");
  return TPAG_VALIDOS.has(normalizado) ? normalizado : null;
}

function _descricaoPagamento(pagamento = {}) {
  return String(
    pagamento.descricao ??
      pagamento.description ??
      pagamento.nome ??
      pagamento.name ??
      ""
  ).trim();
}

export function resolverTpagPagamento(pagamento = {}) {
  const descricao = _descricaoPagamento(pagamento).toLowerCase();
  if (/a\s*prazo|credi[aá]rio|fiado/i.test(descricao)) return "05";

  const codigoExplicito =
    pagamento.tpag ??
    pagamento.tPag ??
    pagamento.tp_pag ??
    pagamento.codigo_pagamento_nfce ??
    pagamento.codigo_nfe ??
    pagamento.codigo_fiscal ??
    null;

  const tpagExplicito = _normalizarCodigo(codigoExplicito);
  if (tpagExplicito && tpagExplicito !== "99") return tpagExplicito;

  for (const { regex, tpag } of REGRAS_DESCRICAO_TPAG) {
    if (regex.test(descricao)) return tpag;
  }

  return tpagExplicito || "99";
}

export function resolverXPagPagamento(pagamento = {}) {
  const xPag = String(pagamento.xPag ?? pagamento.xpag ?? _descricaoPagamento(pagamento)).trim();
  return xPag || "Outros";
}

export function normalizarPagamentoFiscal(pagamento = {}) {
  const tpag = resolverTpagPagamento(pagamento);
  const valor = Number(pagamento.value ?? pagamento.valor ?? 0) || 0;
  let range = Array.isArray(pagamento.range) ? pagamento.range.map((parcela) => ({
    ...parcela,
    value: Number(parcela?.value ?? parcela?.valor ?? 0) || 0,
  })) : [];
  const totalRange = range.reduce((total, parcela) => total + parcela.value, 0);

  if (valor > 0 && totalRange <= 0) {
    const quantidade = Math.max(range.length, Number(pagamento.vezes ?? pagamento.parcelas ?? 1) || 1);
    const valorParcela = Math.round((valor / quantidade) * 100) / 100;
    const hoje = new Date().toISOString().slice(0, 10);
    range = Array.from({ length: quantidade }, (_, index) => ({
      ...(range[index] || {}),
      date: range[index]?.date ?? range[index]?.data ?? pagamento.vencimento ?? hoje,
      value: index === quantidade - 1
        ? Math.round((valor - valorParcela * (quantidade - 1)) * 100) / 100
        : valorParcela,
    }));
  }

  const normalizado = {
    ...pagamento,
    tpag,
    tPag: tpag,
    value: valor,
    valor,
    range,
  };

  if (tpag === "99") {
    normalizado.xPag = resolverXPagPagamento(pagamento);
  }

  return normalizado;
}
